// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"216":"c5c4d6d9","825":"e899295e"}[chunkId] + ".chunk.js");